import React, { useEffect, useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthConsumer } from '../Context/AuthContext';

export default function ProtectedRoute(props) {
    let user = null;

    useEffect(() => {
        user = sessionStorage.getItem("name"); 
    })

    return (
        <AuthConsumer>
            {(consumerProps) => {                
                if (consumerProps.loading) {
                    return (
                        <div>
                            Loading
                        </div>
                    )
                }
                
                if (!consumerProps.user) {
                    return <Redirect to="/" />
                }

                const theProps = {
                    ...props,
                    ...consumerProps
                }

                return <Route {...theProps} />
            }}
        </AuthConsumer>
    )
}